export default __webpack_public_path__ + "static/media/380C5D44-4142-47E6-B1C4-B3734633F109_1_105_c.d420720a.jpeg";